var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.display
    ? _c(
        "div",
        {
          staticClass: "modal-backdrop",
          attrs: { tabindex: "0" },
          on: {
            click: [
              function($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                return _vm.cancel()
              },
              function($event) {
                $event.stopPropagation()
              }
            ],
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              ) {
                return null
              }
              return _vm.cancel()
            }
          }
        },
        [
          _c("div", { staticClass: "cart-modal" }, [
            _c(
              "div",
              {
                staticClass:
                  "cart-modal__body cart-modal__body--spacious cart__confimation"
              },
              [
                _vm.failed
                  ? _c("p", { staticClass: "cart__confimation__heading" }, [
                      _vm._v(
                        "\n        Tarjouksen WC-" +
                          _vm._s(_vm.offerId) +
                          " poisto epäonnistui. Yritä uudelleen?\n      "
                      )
                    ])
                  : _vm.confirmed
                  ? _c("p", { staticClass: "cart__confimation__heading" }, [
                      _vm._v(
                        "\n        Tarjous WC-" +
                          _vm._s(_vm.offerId) +
                          " on poistettu.\n      "
                      )
                    ])
                  : _c("p", { staticClass: "cart__confimation__heading" }, [
                      _vm._v(
                        "\n        Haluatko varmasti poistaa tarjouksen WC-" +
                          _vm._s(_vm.offerId) +
                          "?\n      "
                      )
                    ]),
                _vm._v(" "),
                !_vm.confirmed
                  ? _c("div", { staticClass: "cart__confimation__actions" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn--secondary btn--secondary-med btn--inline",
                          on: {
                            click: [
                              function($event) {
                                $event.preventDefault()
                                return _vm.cancel()
                              },
                              function($event) {
                                $event.stopPropagation()
                              }
                            ]
                          }
                        },
                        [_vm._v("\n          Peruuta\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn--med btn--inline",
                          on: {
                            click: [
                              function($event) {
                                $event.preventDefault()
                                return _vm.confirm()
                              },
                              function($event) {
                                $event.stopPropagation()
                              }
                            ]
                          }
                        },
                        [_vm._v("\n          Poista\n        ")]
                      )
                    ])
                  : _vm._e()
              ]
            )
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-080a895c", { render: render, staticRenderFns: staticRenderFns })
  }
}